import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faArrowLeftLong } from '@fortawesome/free-solid-svg-icons';
import { TranslationKeys } from '@internationalization/translation-keys';
import { RecoverPasswordRequest } from '@models/auth/recover-password-request';
import { ErrorResponse } from '@models/commom/error-response';
import { TranslateService } from '@ngx-translate/core';
import { AuthApiService } from '@services/api/auth-api.service';
import { FormErrorHandlerService } from '@services/helpers/form-error-handler.service';
import { ToastHelperService } from '@services/helpers/toast-helper.service';
import { UtilsService } from '@services/helpers/utils.service';
import { VaultBaseComponent } from '@shared/components/base/vault-base.component';
import { nameof } from '@src/app/core/utils/nameof.utils';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-password-form',
  templateUrl: './password-form.component.html',
  styleUrls: ['./password-form.component.scss'],
  standalone: false,
})
export class PasswordFormComponent extends VaultBaseComponent {
  @Output() sendFormModeChange = new EventEmitter<string>();

  faArrowLeftLong = faArrowLeftLong;

  props = nameof<RecoverPasswordRequest>();

  passwordForm: FormGroup = this.formBuilder.group({
    [this.props.email]: ['', [Validators.required, Validators.email]],
  });

  constructor(
    private formBuilder: FormBuilder,
    private utilService: UtilsService,
    private authApiService: AuthApiService,
    private formErrorHandler: FormErrorHandlerService,
    private toast: ToastHelperService,
    translateService: TranslateService
  ) {
    super(translateService);
  }

  handleFormMode(formMode: string) {
    this.sendFormModeChange.emit(formMode);
  }

  isEmailInvalidOrEmpty(): boolean {
    return this.utilService.isControlInvalidOrEmpty(this.passwordForm, 'email');
  }

  async onSubmit() {
    try {
      this.isLoading = true;
      const recoverPasswordRequest = this.passwordForm.value as RecoverPasswordRequest;
      await lastValueFrom(this.authApiService.recoverPassword(recoverPasswordRequest));

      this.toast.showToastSuccess(
        this.t(TranslationKeys.Auth.RecoverPasswordTitle),
        this.t(TranslationKeys.Auth.RecoverPasswordSuccess)
      );

      this.handleFormMode('login');
    } catch (error) {
      if (error instanceof ErrorResponse) {
        this.formErrorHandler.applyFormErrors(this.passwordForm, error);
      } else {
        console.error(error);
      }
    } finally {
      this.isLoading = false;
    }
  }
}
